// extracted by mini-css-extract-plugin
export default {"card":"CardServices_card__Ayh4E","flipped":"CardServices_flipped__UqiXL","side":"CardServices_side__o8gzt","front":"CardServices_front__u+86p","back":"CardServices_back__0rdwN"};